<template>
  <div id="nav" v-bind:class="{minify: isMinify}">
    <div id="nav_icon" v-bind:class="{active: isMenuActive}" @click="toggle" >
        <div class="hamburger"></div>
    </div>
    <div id="menu_container">
      <ul id="menu-list" v-bind:class="{active: isMenuActive}">
        <li data-linktext="Home" ><router-link to="/">H</router-link></li>
        <li data-linktext="About"><router-link  to="/about">A</router-link></li>
        <li data-linktext="Works"><router-link  to="/works">W</router-link></li>
<!--         <li data-linktext="Blog" ><router-link to="/blog">B</router-link></li>
 -->
        <li data-linktext="Contact" ><router-link to="/contact">C</router-link></li>
      </ul>
    </div>
  </div>
</template>
<script>
  import { Component, Prop, Vue } from 'vue-property-decorator';

  export default {
    mounted: function(){
      this.$el.querySelectorAll("#menu-list li")
      .forEach( li => this.applyDetailMenu( li, li.getAttribute("data-linktext") ));
      window.resizeHandlerExec();
      
    },

    computed: {
      isMenuActive:{
        get(){
          return this.$store.state.menuOn;
        }
      },
      isMinify: {
        get(){
          return this.$store.state.navMinify;
        }
      }
    },
    watch:{
      $route (to, from){
          this.updateCurrentNavigationItem( to.name );
      }
    },


    methods: {
      applyDetailMenu( liElm, text ) {
        var textEl = document.createElement('span');
        textEl.classList.add("detailText");
        Array.from( text ).forEach( w => {
          var span = document.createElement('span');
          span.innerHTML = w;
          textEl.appendChild( span );
        } );
        liElm.appendChild( textEl );
      },

      toggle( event ) {
        this.$store.commit("toggle");
      },

      updateCurrentNavigationItem( routerName ) {
        const _routerName = routerName || "Home"
        console.log( 'changing menu active to : ' + _routerName );
        const currentEl = this.$el.querySelector("li.active");
        const nextEl    = this.$el.querySelector("li[data-linktext='"+routerName + "']");
        if( currentEl != null && currentEl != nextEl ){
          console.log( 'removing current')
          currentEl.classList.remove("active");
        } 
        nextEl.classList.add("active");
      }
    }



  }

</script>
<style>
  @use postcss-preset-env {
    stage: 0;
    autoprefixer: {
      grid: true;
    }
    browsers: [
      "last 1 Chrome versions",
      "last 1 Firefox versions",
      "last 1 Safari versions",
      "last 1 Edge versions"
    ]
  }

</style>
<style lang="scss">
@import "../ui/theme.scss";



#nav{
  position:absolute;
  top:0px;
  left:0px;
  z-index:1;
  transition: all 1s linear;


  #nav_icon{
    position:absolute;
    top: 10px;
    left: 10px;
    overflow:visible;
    z-index:2;
    /*  border: solid 1px orange;*/
    height: 35px;
    width: 30px;
    text-align: center;
    position: relative;
    cursor:pointer;
  }

  #nav_icon .hamburger {
    position: relative;
    height: 3px;
    background-color: white;
    transform: rotate(0deg);
    transition: all ease 400ms;
    opacity: 0.5;
    margin-top: 0;
  }
  #nav_icon .hamburger:before {
    content: "";
    position: absolute;
    display: block;
    top: 6px;
    height: 3px;
    width: 100%;
    background-color: white;
    transform: rotate(0deg);
    transition: all ease 400ms;
  }
  #nav_icon .hamburger:after {
    content: "";
    position: absolute;
    display: block;
    top: 12px;
    height: 3px;
    width: 100%;
    background-color: white;
    transform: rotate(0deg);
    transition: all ease 400ms;
  }

  #nav_icon.active .hamburger {
    background-color: rgba(255, 255, 255, 0);
    opacity: 1;
    margin-top: 5px;
  }
  #nav_icon.active .hamburger:after {
    transform: translateY(-6px) rotate(-45deg);
  }
  #nav_icon.active .hamburger:before {
    transform: rotate(45deg);
  }

  ul#menu-list{
      li span.detailText{
        color: var(--basecolor);
      }
  }

  &:not(.minify){


    height:100%;
    background-color: $menu_bg-color;
    width: 2em;
    padding:0 0.5em;


    #nav_icon{
      left:0px;
    }
    ul#menu-list {
      position:relative;
      padding-inline-start: unset;
      margin-block-start: unset;
      display: flex;
      flex-direction: column;
    }

    ul#menu-list li {
      position: relative;
      display: inline-block;
      transition: opacity 2s  linear;
      width:2em;
      text-align:center;
      margin-top: -2em;
      transition: margin-top 0.5s linear 0.5s;

    }

    ul#menu-list li a { 
      transition: transform 0.5s linear 0.5s, opacity 0.5s linear 0s;
      transform: rotateX(-90deg);
      opacity: 0;
    }

    ul#menu-list li:hover {
      opacity:1;
    }

    ul#menu-list.active li {
      transition: margin-top 0.5s linear 0;
      margin-top: 2em;
    }

    ul#menu-list.active li a { 
      transition: transform 1s linear 0.5s, opacity 0.5s linear 0s;
      transform: rotateX(0deg);
      opacity: 1;
    }



    ul#menu-list li a {
        display:inline-block;
        color: var(--basecolor);
        text-decoration: none;
    /*    background-color: #FFF;  
    */
    }

     /*---- menu detail text -----*/



    ul#menu-list{

      li span.detailText{
        visibility: hidden;
        display: inline-block;
        visibility: hidden;
        position: absolute;
        margin-left: 1em;
        margin-top: 0em;
        width: -webkit-max-content;
        width: -moz-max-content;
        width: max-content;
        top: 0px;
        color: var(--basecolor);

      }

      li span.detailText span{
        display: inline-block;
        opacity:0;
        margin-left:-2.5em;
        transform: rotateY(90deg);
      }
        

      li span.detailText span:nth-child(1){
        display:none;
      }

      &.active {

        li span.detailText span:nth-child(1){
          display:none;
        }

        li.active{
          a {
            padding: 0.5em;
            background: rgba(255,255,255,0.8);
            margin-top: -0.5em;
            border-radius: 50%;
          }
          span.detailText{
            trasition: border-bottom 1s linear 1s;
            border-bottom: 1px solid #FFF;
            padding: 0px 10px 0px 0px;
          }
        }


        li:hover span.detailText,
        li.active span.detailText{
          visibility: visible;
        }

        li:hover span.detailText span,
        li.active span.detailText span{
          opacity:1;
          transform: rotateY(0deg);
          margin-left:0.5em;
          transition: opacity 2s linear, margin-left 1.5s ease,  transform  1s  linear 0.5s;
        }


        li:hover span.detailText span:nth-child(2){
          transition: transform  1s  linear 0.2s;
        }

        li:hover span.detailText span:nth-child(3){
          transition: transform  1s  linear 0.4s;
        }
        li:hover span.detailText span:nth-child(4){
          transition: transform  1s  linear 0.5s;
        }
        li:hover span.detailText span:nth-child(5){
          transition: transform  1s  linear 0.6s;
        }
        li:hover span.detailText span:nth-child(6){
          transition: transform  1s  linear 0.8s;
        }
        li:hover span.detailText span:nth-child(7){
          transition: transform  1s  linear 1s;
        }
        li:hover span.detailText span:nth-child(8){
          transition: transform  1s  linear 1.2s;
        }      
      }
    }


  }

  &.minify{

    height:max-content;



    #menu_container{
      position: fixed;
      top: 0px;
      left: 0px;
      width: 10px;
      height: 0px;
      background-color: #fd79a850;
      align-items: center;
      justify-content: center;
      transform-origin: top left;
      z-index: 1;
    }
    ul#menu-list {
      top:0px;
      left:0px;
      position:relative;
      top: 0px;
      left: 0px;
      position: relative;
      padding-inline-start: unset;
      margin-block-start: unset;
    }

    ul#menu-list li {
      display: inline-block;
      position:absolute;
      opacity:0;
      top:0px;
      left:0px;
      transition: opacity 2s  linear,  top 1s cubic-bezier(.17,.67,0,1.39), left  1s cubic-bezier(.17,.67,0,1.39);
    }
    ul#menu-list.active li {
      opacity:1;
    }

    ul#menu-list li:hover{
      z-index:2;
    }


    ul#menu-list.active li:nth-child(1) {
      top:0px;
      left: 150px;
      transition-delay: 0.2s;
    }
    ul#menu-list.active li:nth-child(2) {
      top:57px;
      left: 138px;
      transition-delay: 0.4s;
    }

    ul#menu-list.active li:nth-child(3) {
      top: 106px;
      left: 106px;
      transition-delay: 0.5s;
    }

    ul#menu-list.active li:nth-child(4) {
      top: 138px;
      left: 57px;
      transition-delay: 0.6s;

    }

    ul#menu-list.active li:nth-child(5) {
      top: 150px;
      left: 0px;
      transition-delay: 0.8s;

    }



    ul#menu-list.active li:nth-child(2) a{
      animation-delay: 0.2s;
    }
    ul#menu-list.active li:nth-child(3) a{
      animation-delay: 0.25s;
    }
    ul#menu-list.active li:nth-child(4) a{
      animation-delay: 0.3s;
    }

    ul#menu-list.active li:nth-child(5) a{
      animation-delay: 0.35s;
    }

    ul#menu-list.active li a{
      display: inline-block;
      text-align: center;
      padding:1em;
      display: block;
      width: max-content;
      height: max-content;  
      background-color: var(--blob);  
      box-shadow: var(--shades);
      background-size: 1600% 1600%;
      transform-origin: 50% 50%;
      transform-style: preserve-3d;
      perspective: 1000px;
      transition: all 1s;
      top:50%;
      animation: 
        bubble 5s ease-in-out infinite both alternate,
        movement 10s ease-in-out infinite both;
    }





    ul#menu-list li a {
        float: left;
        color: var(--basecolor);
        text-decoration: none;
    /*    background-color: #FFF;  
    */
    }


    ul#menu-list li:hover a{
      padding:1.5em;
      margin-top:-0.5em;
      margin-left:-0.5em;
      background-color: #FFF;  
    }
    ul#menu-list.active li.active {
      opacity: 1;
    }

    ul#menu-list li.active a,
    ul#menu-list li:hover a {
      background-color: #FFF;  
    }
    /*---- menu detail text -----*/

    ul#menu-list li span.detailText{
      visibility: hidden;
      display: inline-block;
      visibility: hidden;
      position: absolute;
      margin-left: 0.5em;
      margin-top: 0.5em;
    }

    ul#menu-list li span.detailText span{
      display: block;
      opacity:0;
      margin-left:-2.5em;
      transform: rotateX(90deg);
    /*  transition: all 1.5s;
    */  text-align: center;
    }

    ul#menu-list li:hover span.detailText{

      visibility: visible;
    }

    ul#menu-list li:hover span.detailText span{
      opacity:1;
      transform: rotateX(0deg);
      margin-left: 0px;
      transition: opacity 2s linear, margin-left 1.5s ease,  transform  1s  linear 0.5s;
    }

    ul#menu-list li:hover a span.detailText span:nth-child(2){
      transition: transform  2s  linear 1s;
    }
    ul#menu-list li:hover a span.detailText span:nth-child(3){
      transition: transform  2s  linear 1.5s;
    }
    ul#menu-list li:hover a span.detailText span:nth-child(4){
      transition: transform  2s  linear 2s;
    }
    ul#menu-list li:hover a span.detailText span:nth-child(5){
      transition: transform  2s  linear 2.5s;
    }
    ul#menu-list li:hover a span.detailText span:nth-child(6){
      transition: transform  2s  linear 3s;
    }
    ul#menu-list li:hover a span.detailText span:nth-child(7){
      transition: transform  2s  linear 3.5s;
    }


  }



}

@keyframes bubble {
    0%,
  100% { border-radius: 63% 37% 54% 46% / 55% 48% 52% 45%; } 
   14% { border-radius: 40% 60% 54% 46% / 49% 60% 40% 51%; } 
   28% { border-radius: 54% 46% 38% 62% / 49% 70% 30% 51%; } 
   42% { border-radius: 61% 39% 55% 45% / 61% 38% 62% 39%; } 
   56% { border-radius: 61% 39% 67% 33% / 70% 50% 50% 30%; } 
   70% { border-radius: 50% 50% 34% 66% / 56% 68% 32% 44%; } 
   84% { border-radius: 46% 54% 50% 50% / 35% 61% 39% 65%; } 
}


@keyframes movement {
    0%,
  100% { transform: none; }
   50% { transform: translateY(20%) rotateY(10deg); }
}

</style>